import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-lg-row flex-column-fluid" }
const _hoisted_2 = { class: "d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1" }
const _hoisted_3 = { class: "d-flex flex-center flex-column flex-lg-row-fluid" }
const _hoisted_4 = { class: "<?php echo $params['wrapperClass']?> p-0 p-md-10" }
const _hoisted_5 = { class: "d-flex justify-content-between mt-5 ms-0 ms-md-20" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"me-10 d-flex gap-5 px-0 px-md-15 d-none\"><a href=\"https://www.facebook.com/perufedup/\" target=\"_blank\" class=\"text-hover-primary\"><i class=\"fab fa-facebook-f\"></i></a><a href=\"https://twitter.com/perufedup\" target=\"_blank\" class=\"text-hover-primary\"><i class=\"fab fa-twitter\"></i></a><a href=\"https://www.instagram.com/perufedup/\" target=\"_blank\" class=\"text-hover-primary\"><i class=\"fab fa-instagram\"></i></a><a href=\"https://pe.linkedin.com/company/perufedup\" target=\"_blank\" class=\"text-hover-primary\"><i class=\"fab fa-linkedin-in\"></i></a></div>", 1)
const _hoisted_7 = { class: "d-flex flex-center flex-wrap px-5 m-0 me-md-20" }
const _hoisted_8 = { class: "d-flex fw-semibold text-primary fs-base gap-5 m-0 me-md-10" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "text-muted ms-1" }
const _hoisted_11 = {
  class: "d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2",
  style: {"background-image":"url('media/misc/auth-bg2.png')"}
}
const _hoisted_12 = { class: "d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100" }
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h1", { class: "d-none d-lg-block text-white fs-2qx fw-bolder text-center mb-7" }, " Sistema Deportivo Universitario ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_view)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("a", {
              href: _ctx.terms,
              target: "_blank"
            }, "Terms", 8, _hoisted_9),
            _createElementVNode("span", _hoisted_10, "versión " + _toDisplayString(_ctx.version), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        (_ctx.asideTheme === 'dark')
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.brandDarkLogo,
              alt: _ctx.appName,
              class: "d-none d-lg-block mx-auto w-275px w-md-50 w-xl-500px mb-10 mb-lg-20"
            }, null, 8, _hoisted_13))
          : _createCommentVNode("", true),
        (_ctx.asideTheme === 'light')
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _ctx.brandLightLogo,
              alt: _ctx.appName,
              class: "d-none d-lg-block mx-auto w-275px w-md-50 w-xl-500px mb-10 mb-lg-20"
            }, null, 8, _hoisted_14))
          : _createCommentVNode("", true),
        _hoisted_15
      ])
    ])
  ]))
}